<template>
  <div id="app" v-loading="DDLoading" element-loading-text="钉钉账号登录中...">
    <!-- <img src="./assets/logo.png"> -->
    <transition name="fade" mode="out-in" v-if="isRouterAlive">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi'
import { getMenu, getTokenInfo } from './utils/auth'
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      DDLoading: false,
      code: '',
      corpId: window.g.CORPID
    };
  },
  mounted() {
    this.isDDReady()
    if (window.g.SYSUPDATE) {
      this.sysupdateTips()
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 移动端dd免登录
    isDDReady() {
      const that = this
      if (dd.env.platform !== "notInDingTalk") {
        //进行钉钉登录操作
        dd.ready(() => {
          dd.runtime.permission.requestAuthCode({
            corpId: that.corpId, // 企业id
            onSuccess: (info) => {
              //todo: 测试获取授权码
              that.code = info.code // 通过该免登授权码可以获取用户身份
              // that.$message.success(that.code)
              this.DDLogin()
            },
            onFail: (error) => {
              that.$message.error(JSON.stringify(error))
            }
          })
        })
      }
    },
    DDLogin() {
      const that = this
      var loginParams = {
        code: this.code
      }
      that.DDLoading = true
      that.$store
        .dispatch("user/DDloginByDingApp", loginParams)
        .then(res => {
          that.$message.success("登录成功！");
          //登录成功
          that.$router.push({
            path: that.flrPath()
          })
          that.DDLoading = false
        })
        .catch(() => {
          that.$router.push({
            path: '/login'
          })
          that.DDLoading = false
        })
    },
    sysupdateTips() {
      this.$notify.warning({
        title: '系统停机更新',
        message: `
        <p>开始时间：${window.g.SYSUPDATE_ST}</p>
        <p>结束时间：${window.g.SYSUPDATE_ET}</p>
        `,
        dangerouslyUseHTMLString: true,
        position: 'bottom-right',
        customClass: 'sysUpdate',
        duration: 0
      })
    },
    flrPath() {
      // 判断设置的几个目录是否存在
      const menuList = JSON.stringify(getMenu())
      if (menuList.indexOf('hospitallist') >= 0 && menuList.indexOf('医院列表') >= 0) {
        return '/hospital/list'
      } else if (menuList.indexOf('hospitallist') >= 0 && menuList.indexOf('我的医院') >= 0) {
        return '/hospital/listmy'
      } else {
        return '/'
      }
    },
  },
  components: {}
};
</script>

<style lang="scss">
@import "~scss_index";
@import "~scss_vars";
body {
  margin: 0px;
  padding: 0px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}
#app {
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.el-submenu [class^="fa"] {
  vertical-align: -1px;
  margin-right: 10px;
}
.el-menu-item [class^="fa"] {
  vertical-align: baseline;
  margin-right: 10px;
}
.toolbar {
  font: 14px "微软雅黑";
  color: $color-primary;
  background: #f2f2f2;
  padding: 10px 15px;
  margin: 10px 0px;
  .el-form-item {
    margin-bottom: 10px;
  }
}
.headTip {
  padding: 10px 15px;
  margin: 10px auto;
  font: 14px "微软雅黑";
  color: #fff;
  background: $color-primary;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.sysUpdate {
  background-color: rgba(245, 108, 108, 0.9);
  border-color: rgba(245, 108, 108, 0.9);
  .el-notification__icon {
    color: #fff;
  }
  .el-notification__title {
    color: #fff;
    margin-top: 4px;
  }
  .el-notification__content {
    color: #fff;
  }
  .el-notification__closeBtn {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/web/App.vue